// extracted by mini-css-extract-plugin
export default {"panelWrapper":"ResultsPanel_panelWrapper__tSHbe"};